import React from 'react';
import SEO from "../components/SEO";
import BackButton from '../components/BackButton';
import axios from '../api/axios';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';

export default function CourseAssessments() {
  const { slug } = useParams();
  const currentIndex = 1;
  const [course, setCourse] = useState({});
  const [assessments, setAssessments] = useState([]);
  const [courses, setCourses] = useState([]);


  useEffect(() => {
    // Fetch the current course and its assessments
    axios.get(`/courses/${slug}`)
      .then(res => {
        setCourse(res.data);  // Set current course details
        setAssessments(res.data.assessments); // Set assessments for the current course
      })
      .catch(() => alert('Failed to load course details'));

    // Fetch all courses to display related courses
    axios.get('/courses')
      .then(res => setCourses(res.data))
      .catch(() => alert('Failed to load all courses'));
  }, [slug]);

  return (
    <>
      <SEO
        title={course?.meta_title || "Free Skill Assessment &amp; Practice Tests"}
        description={course?.meta_description || "Test your skills with the most comprehensive free practice tests to help you assess where you stand on the most popular IT &amp; Security skill sets."}
        keywords={course?.meta_keywords || undefined}
        canonical={typeof window !== "undefined" ? window.location.href : undefined}
      />
      <section className="bg-[#F6F6F6] py-[36px] md:py-[52px]">

        <div className="container mx-auto px-4">
          <BackButton />
          <h1 className="font-bold text-center mb-6 text-[18px] md:text-[28px]">
            {course.title}
          </h1>

          {/* Assessments Section */}
          <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-6">
            {assessments.map((assessment) => (
              <div key={assessment.title} className="overflow-hidden group rounded-[16px] border border-[#D9D9D9] bg-white h-full hover:border-red-600 transition-colors">
                <div className="p-4 bg-white rounded-t-lg flex flex-col gap-4">
                  <h3 className="text-gray-900 text-base font-bold leading-normal min-h-[60px]">
                    {assessment.title}
                  </h3>
                  <ul className="flex justify-between flex-wrap gap-4">
                    <li className="flex items-center gap-2 leading-none">
                      <span className="text-gray-700 text-sm font-semibold">{assessment.duration_minutes} Min</span>
                    </li>
                    <li className="flex items-center gap-2 leading-none">
                      <span className="text-gray-700 text-sm font-semibold">{assessment.total_questions} Questions</span>
                    </li>
                  </ul>
                </div>
                <div>
                  <Link
                    to={`/assessment/${assessment.slug}/form`}
                    className="block px-6 py-3 w-full bg-grey-600 text-grey-disable text-center font-bold uppercase no-underline hover:bg-bg-gradient-orange hover:text-white group-hover:bg-bg-gradient-orange group-hover:text-white transition"
                  >
                    Attempt Now
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      {courses.length > 0 && (
        <section className="bg-[#ffffff] py-[36px] md:py-[72px]">
          <div div className="container mx-auto px-4">
            {/* Related Courses Section (Excluding the Current Course) */}

            <h2 className="font-bold text-center mb-6 text-[24px] md:text-[28px]">
              Other Courses You Might Like
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-6 demand-course-flex">
              {courses.filter(course => course.slug !== slug).map((course) => (
                <div key={course.id} className="flex flex-col gap-6">
                  <div className="overflow-hidden group flex flex-col h-full rounded-[16px] border border-[#d9d9d9] bg-white hover:border-red-600">

                    {/* Image */}
                    <img
                      src={course.image ?? "https://www.infosectrain.com/wp-content/uploads/2024/08/feature-default.webp"}
                      alt="InfosecTrain Trending Courses"
                      className="w-full h-auto block rounded-t-[16px]"
                      loading="lazy"
                    />
                    <div className="p-4 bg-white rounded-t-lg flex flex-col gap-4">
                      <h3 className="text-gray-900 text-base font-bold leading-normal min-h-[60px]">
                        {course.title}
                      </h3>
                    </div>
                    <div>
                      <Link
                        to={`/courses/${course.slug}`} target='_blank'
                        className="block px-6 py-3 w-full bg-grey-600 text-grey-disable text-center font-bold uppercase no-underline hover:bg-bg-gradient-orange hover:text-white group-hover:bg-bg-gradient-orange group-hover:text-white transition"
                      >
                        View Course
                      </Link>
                    </div>
                  </div>
                </div>
              ))}
            </div>

          </div>
        </section>
      )}
    </>
  )
}

function ClockIcon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" viewBox="0 0 14 15" fill="none">
      <g clipPath="url(#clip0_15884_2401)">
        <path d="M7.87498 1.73375V1.375C7.87498 1.14294 7.7828 0.920376 7.6187 0.756282C7.45461 0.592187 7.23205 0.5 6.99998 0.5C6.76792 0.5 6.54536 0.592187 6.38126 0.756282C6.21717 0.920376 6.12498 1.14294 6.12498 1.375V1.73375C5.01219 1.88401 3.95854 2.32449 3.06991 3.01094C2.18127 3.69738 1.48894 4.60561 1.06249 5.64437C0.63604 6.68313 0.490483 7.81583 0.640445 8.92867C0.790408 10.0415 1.23061 11.0953 1.91682 11.9841C1.67529 12.1826 1.48219 12.4336 1.35221 12.7179C1.22222 13.0022 1.15876 13.3125 1.16665 13.625C1.16665 13.8571 1.25884 14.0796 1.42293 14.2437C1.58703 14.4078 1.80959 14.5 2.04165 14.5C2.27372 14.5 2.49627 14.4078 2.66037 14.2437C2.82446 14.0796 2.91665 13.8571 2.91665 13.625C2.90774 13.5383 2.92938 13.4512 2.97784 13.3788C3.0263 13.3064 3.09854 13.2532 3.18207 13.2283C4.28368 14.0532 5.62288 14.4991 6.99911 14.4991C8.37534 14.4991 9.71453 14.0532 10.8161 13.2283C10.9 13.2528 10.9726 13.3059 11.0214 13.3784C11.0702 13.4508 11.0921 13.5381 11.0833 13.625C11.0833 13.8571 11.1755 14.0796 11.3396 14.2437C11.5037 14.4078 11.7263 14.5 11.9583 14.5C12.1904 14.5 12.4129 14.4078 12.577 14.2437C12.7411 14.0796 12.8333 13.8571 12.8333 13.625C12.8412 13.3125 12.7777 13.0022 12.6478 12.7179C12.5178 12.4336 12.3247 12.1826 12.0831 11.9841C12.7694 11.0953 13.2096 10.0415 13.3595 8.92867C13.5095 7.81583 13.3639 6.68313 12.9375 5.64437C12.511 4.60561 11.8187 3.69738 10.9301 3.01094C10.0414 2.32449 8.98777 1.88401 7.87498 1.73375ZM2.33332 8.08333C2.33332 7.16035 2.60701 6.2581 3.11979 5.49067C3.63257 4.72324 4.36141 4.1251 5.21413 3.7719C6.06685 3.41869 7.00516 3.32627 7.9104 3.50634C8.81565 3.6864 9.64717 4.13086 10.2998 4.7835C10.9525 5.43615 11.3969 6.26767 11.577 7.17291C11.757 8.07816 11.6646 9.01647 11.3114 9.86919C10.9582 10.7219 10.3601 11.4507 9.59264 11.9635C8.82521 12.4763 7.92296 12.75 6.99998 12.75C5.76273 12.7486 4.57656 12.2565 3.70169 11.3816C2.82682 10.5068 2.33471 9.32058 2.33332 8.08333Z" fill="#E50914" />
        <path d="M11.375 0.500149C11.1429 0.500149 10.9204 0.592336 10.7563 0.756431C10.5922 0.920525 10.5 1.14308 10.5 1.37515C10.5 1.60721 10.5922 1.82977 10.7563 1.99387C10.9204 2.15796 11.1429 2.25015 11.375 2.25015C11.4911 2.24112 11.6079 2.25775 11.7168 2.29888C11.8258 2.34001 11.9244 2.40461 12.0057 2.48812C12.0869 2.57163 12.1488 2.67199 12.1868 2.78208C12.2249 2.89217 12.2383 3.0093 12.2261 3.12515C12.2261 3.35721 12.3183 3.57977 12.4824 3.74387C12.6465 3.90796 12.869 4.00015 13.1011 4.00015C13.3331 4.00015 13.5557 3.90796 13.7198 3.74387C13.8839 3.57977 13.9761 3.35721 13.9761 3.12515C13.9896 2.77884 13.9317 2.43345 13.8061 2.11044C13.6805 1.78744 13.4898 1.49372 13.2459 1.24753C13.0019 1.00135 12.7099 0.807963 12.3881 0.679391C12.0663 0.550818 11.7214 0.489807 11.375 0.500149Z" fill="#E50914" />
        <path d="M1.77389 3.12515C1.76165 3.0093 1.77504 2.89217 1.81313 2.78208C1.85122 2.67199 1.91308 2.57163 1.9943 2.48812C2.07553 2.40461 2.17414 2.34001 2.28313 2.29888C2.39212 2.25775 2.50883 2.24112 2.62498 2.25015C2.85704 2.25015 3.0796 2.15796 3.2437 1.99387C3.40779 1.82977 3.49998 1.60721 3.49998 1.37515C3.49998 1.14308 3.40779 0.920525 3.2437 0.756431C3.0796 0.592336 2.85704 0.500149 2.62498 0.500149C2.27856 0.489807 1.93371 0.550818 1.61187 0.679391C1.29003 0.807963 0.998065 1.00135 0.754124 1.24753C0.510184 1.49372 0.319477 1.78744 0.193856 2.11044C0.0682348 2.43345 0.0103826 2.77884 0.0238944 3.12515C0.0238944 3.35721 0.116082 3.57977 0.280176 3.74387C0.44427 3.90796 0.66683 4.00015 0.898894 4.00015C1.13096 4.00015 1.35352 3.90796 1.51761 3.74387C1.68171 3.57977 1.77389 3.35721 1.77389 3.12515Z" fill="#E50914" />
        <path d="M7.89252 7.72125V5.4585C7.89252 5.22643 7.80033 5.00387 7.63624 4.83978C7.47214 4.67568 7.24958 4.5835 7.01752 4.5835C6.78545 4.5835 6.56289 4.67568 6.3988 4.83978C6.2347 5.00387 6.14252 5.22643 6.14252 5.4585V7.96275C6.14258 8.27214 6.26554 8.56884 6.48435 8.78758L7.53027 9.8335C7.69529 9.99288 7.91632 10.0811 8.14574 10.0791C8.37517 10.0771 8.59463 9.98507 8.75686 9.82284C8.91909 9.6606 9.01111 9.44114 9.01311 9.21172C9.0151 8.9823 8.92691 8.76127 8.76752 8.59625L7.89252 7.72125Z" fill="#E50914" />
      </g>
      <defs>
        <clipPath id="clip0_15884_2401">
          <rect width="14" height="14" fill="white" transform="translate(0 0.5)" />
        </clipPath>
      </defs>
    </svg>
  );
}

function QuestionSquareIcon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" viewBox="0 0 14 15" fill="none">
      <g clip-path="url(#clip0_15884_2408)">
        <path d="M9.29717 5.33467C9.471 6.324 9.00025 7.31275 8.12583 7.79458C8.12583 7.79458 7.88375 7.92175 7.854 7.9375C7.76242 8.33242 7.41242 8.66725 7.00058 8.66725C6.5275 8.65383 6.12558 8.26592 6.12558 7.79225C6.12558 6.86767 6.78475 6.52292 7.13883 6.338L7.28058 6.26275C7.45033 6.16942 7.62825 5.9495 7.57342 5.638C7.53433 5.41458 7.33658 5.21683 7.11317 5.17775C6.75558 5.11358 6.45458 5.36208 6.39917 5.63333C6.30292 6.10642 5.84092 6.40917 5.36725 6.31642C4.89358 6.22017 4.58792 5.75817 4.68417 5.2845C4.93442 4.05367 6.16058 3.23233 7.41592 3.45342C8.358 3.6185 9.1315 4.39258 9.29717 5.33467ZM7 9.83333C6.517 9.83333 6.125 10.2253 6.125 10.7083C6.125 11.1913 6.517 11.5833 7 11.5833C7.483 11.5833 7.875 11.1913 7.875 10.7083C7.875 10.2253 7.483 9.83333 7 9.83333ZM14 3.70833V11.2917C14 13.0603 12.5609 14.5 10.7917 14.5H3.20833C1.43908 14.5 0 13.0603 0 11.2917V3.70833C0 1.93908 1.43908 0.5 3.20833 0.5H10.7917C12.5609 0.5 14 1.93908 14 3.70833ZM12.25 3.70833C12.25 2.9045 11.5955 2.25 10.7917 2.25H3.20833C2.4045 2.25 1.75 2.9045 1.75 3.70833V11.2917C1.75 12.0961 2.4045 12.75 3.20833 12.75H10.7917C11.5955 12.75 12.25 12.0961 12.25 11.2917V3.70833Z" fill="#E50914" />
      </g>
      <defs>
        <clipPath id="clip0_15884_2408">
          <rect width="14" height="14" fill="white" transform="translate(0 0.5)" />
        </clipPath>
      </defs>
    </svg>
  );
}
